import type { CSSProperties, ReactNode } from "react";
import { TYPE } from "@chess/shared";
import { useTheme } from "@/theme/ThemeProvider";

interface Props {
  children: ReactNode;
  bg?: string;
  fg?: string;
  style?: CSSProperties;
}

export function BrTag({ children, bg, fg, style = {} }: Props) {
  const p = useTheme();
  return (
    <span
      style={{
        background: bg || p.accent,
        color: fg || p.accentFg,
        border: `2px solid ${p.border}`,
        padding: "3px 8px",
        fontSize: 10.5,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.8,
        fontFamily: TYPE.mono,
        display: "inline-block",
        transition: "background .25s, color .25s, border-color .25s",
        ...style,
      }}
    >
      {children}
    </span>
  );
}
